export default "__VITE_ASSET__A8Z84Jq9__"